import {useQueryClient} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {ActionTypeLoggingAccessEnum} from 'domain/usecases/private/my-hospitalization/post-logging-access';
import {useGetConciergeUrlQuery} from '../../pages/Home/queries/useGetConciergeUrlQuery';
import {useOpenConciergeIframeStore} from '../../../home/store/useOpenConciergeIframeStore';
import {useMyHospitalizationLoggingAccess} from '../useMyHospitalizationLoggingAccess';

const STOP_AUTO_RUN = true;

export function useConcierge() {
	const {handleLog} = useMyHospitalizationLoggingAccess(
		ActionTypeLoggingAccessEnum.CONCIERGE,
		STOP_AUTO_RUN,
	);
	const queryClient = useQueryClient();
	const setOpenConciergeIframeState = useOpenConciergeIframeStore(
		state => state.setOpenIframeState,
	);
	const openConciergeIframeState = useOpenConciergeIframeStore(state => state.openIframeState);

	const {data: conciergeUrl, isError, isFetching, refetch} = useGetConciergeUrlQuery();

	const handleOpenUrl = async () => {
		const {data: url, isSuccess} = await refetch();
		if (url && isSuccess) {
			setOpenConciergeIframeState(true);
			handleLog();
		}
	};

	const handleCloseIframe = () => {
		setOpenConciergeIframeState(false);
	};

	const handleCloseErrorModal = () => {
		queryClient.resetQueries({queryKey: [QUERY_KEYS.CONCIERGE_URL]});
	};

	return {
		openConciergeIframe: openConciergeIframeState,
		setOpenConciergeIframe: setOpenConciergeIframeState,
		isError,
		isFetching,
		handleOpenUrl,
		handleCloseErrorModal,
		conciergeUrl,
		handleCloseIframe,
	};
}
